import { styled } from 'styled-components';
import { pxToRem } from 'utils/ui/units';
import { Box } from 'components/Flex';
export var HANDLE_PX = 6;
export var ResizeHandleHorizontal = styled(Box).attrs(function () {
  return {
    height: pxToRem(HANDLE_PX),
    shrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  };
}).withConfig({
  displayName: "ResizeHandle__ResizeHandleHorizontal",
  componentId: "sc-izjfcx-0"
})(["cursor:ns-resize;&::after{content:'';width:", ";height:", ";border-radius:", ";background-color:", ";opacity:0.4;transition:opacity 0.15s;}&:hover::after{opacity:1;}"], pxToRem(32), pxToRem(3), pxToRem(2), function (p) {
  return p.theme.sections.card.shade;
});

// Caller passes left={0} or right={0} to position on the desired edge.
export var ResizeHandleVertical = styled(Box).attrs(function () {
  return {
    position: 'absolute',
    top: 0,
    bottom: 0,
    width: pxToRem(HANDLE_PX),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  };
}).withConfig({
  displayName: "ResizeHandle__ResizeHandleVertical",
  componentId: "sc-izjfcx-1"
})(["cursor:ew-resize;z-index:9999;transform:translateZ(0);&::after{content:'';width:", ";height:", ";border-radius:", ";background-color:", ";opacity:0.4;transition:opacity 0.15s;}&:hover::after{opacity:1;}"], pxToRem(3), pxToRem(32), pxToRem(2), function (p) {
  return p.theme.sections.card.shade;
});